import React from 'react';

import './simpleeditor.scss';

export default function SimpleEditor({ content = "", handleChange = (e, content)=>{}, 
    editorMinHeight = "14em", editorMaxHeight = "20em", maxLength = null, ...props }) {
    
    const [state, setState] = React.useState({
        editorFocussed: false,
    });
    
    function onChange(e) {
        handleChange(e, e.currentTarget.value);
    }

    return (
        <textarea
            value={content}
            style={{
                minHeight: editorMinHeight,
                maxHeight: editorMaxHeight,
                resize: "vertical",
            }}
            className={"simpleeditor" + (state.editorFocussed ? " simpleeditor--active" : "") }
            onFocus={() => setState({
                ...state,
                editorFocussed: true,
            })}
            onBlur={() => setState({
                ...state,
                editorFocussed: false,
            })}
            onChange={onChange}
            {...(maxLength !== null ? {maxlength: maxLength} : {})}
            {...props}
            autoFocus
        />          
    );
}